// extracted by mini-css-extract-plugin
export default {"pelvic_table":"GaitTestResults_pelvic_table__s1WTV"};